import moment from "moment";

const DEFAULTS = {
  provisionalNo: "<strong> <<< Provisional Appointing Letter No >>> </strong>",
  provisionalDate:
    "<strong> <<< Provisional Appointing Letter Date >>> </strong>",
  recruitmentReportNo: "<strong> <<< Recruitment Report No >>> </strong>",
  recruitmentReportDate: "<strong> <<< Recruitment Report Date >>> </strong>",
  appointmentNo: "<strong> <<< Appointment Letter No >>> </strong>",
  appointmentDate: "<strong> <<< Appointment Letter Date >>> </strong>",
};

export const buildAdministrationLetterCustomization = (
  item,
  requestTypeId,
  recruitmentRequests
) => {
  // `recruitmentRequests` can be either:
  // - an array of requests (OverallResults flow), or
  // - an object that contains the array plus extra metadata (EmployeeCard flow),
  //   or it might be null/undefined when the API call fails (e.g. 401).
  const requestsArray = Array.isArray(recruitmentRequests)
    ? recruitmentRequests
    : Array.isArray(recruitmentRequests?.requests)
    ? recruitmentRequests.requests
    : [];

  const request = requestsArray.find(
    (request) => request.requestTypeId === requestTypeId
  );
  const provisionalAppointment = requestsArray.find(
    (request) => request.requestTypeId === 1
  );

  if (requestTypeId === 1) {
    return {
      requestTypeId: 1,
      effectiveDate: item.employmentDate || new Date(),
      positionName:item.positionName,
      entityName:item.entityName
    };
  }

  if (requestTypeId === 2) {
    return {
      requestTypeId: 2,
      positionName:item.positionName,
      entityName:item.entityName,
      effectiveDate:
        +item.recruitmentRequestId <= 0
          ? item.employmentDate || new Date()
          : new Date(),
      provisionalAppointmentReference: `<p style="font-family: Times New Roman;font-size: 16px;">
Reference is made to the letter No. ${
  provisionalAppointment?.docLetterNo
          ? provisionalAppointment.docLetterNo
          : DEFAULTS.provisionalNo
      } of ${
        provisionalAppointment?.effectiveOn
          ? moment(provisionalAppointment?.effectiveOn).format("LL")
          : DEFAULTS.provisionalDate
      } Appointing you provisionally on the job position of ${
        item.positionName || provisionalAppointment?.positionName || ""
      } In/at ${item.entityName || provisionalAppointment?.entityName || ""};
</p>`,
      reportReference: `<p style="font-family: Times New Roman;font-size: 16px;">
${"Further reference"} is made the recruitment report No NPSC/${
  request.reportReferenceNo ? request.reportReferenceNo : DEFAULTS.recruitmentReportNo
      } for the job position of ${item.positionName || ""} In/at ${
        item.entityName || ""
      } approved on ${
        item.reportEffectiveOn
          ? moment(item.reportEffectiveOn).format("LL")
          : DEFAULTS.recruitmentReportDate
      } by National Public Service Commission (NPSC);
</p>`,
    };
  }

  return {
    requestTypeId: 3,
    positionName:item.positionName,
    entityName:item.entityName,
    effectiveDate: new Date(),
    appointmentReferenceNo: item.appointedLetterDocLetterNo
      ? item.appointedLetterDocLetterNo
      : DEFAULTS.appointmentNo,
    appointmentReferenceDate: item.appointedLetterEffectiveOn
      ? moment(item.appointedLetterEffectiveOn).format("LL")
      : DEFAULTS.appointmentDate,
  };
};

export const handleAdministrationLetterRequest = ({
  item,
  requestTypeId,
  onClosePopover,
  onCloseMenu,
  setInitiateLetterCustomization,
  setShowRequestForm,
  recruitmentRequests,
}) => {
  onClosePopover();
  onCloseMenu();

  setInitiateLetterCustomization(
    buildAdministrationLetterCustomization(item, requestTypeId, recruitmentRequests)
  );

  setShowRequestForm(true);
};

